import { render, staticRenderFns } from "./IconSvgCalendarCheck.vue?vue&type=template&id=4d4c0406&scoped=true&"
import script from "./IconSvgCalendarCheck.vue?vue&type=script&lang=js&"
export * from "./IconSvgCalendarCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c0406",
  null
  
)

export default component.exports